import { render } from "./CollectionSourceTransactions.vue?vue&type=template&id=473e91c7&scoped=true"
import script from "./CollectionSourceTransactions.vue?vue&type=script&lang=js"
export * from "./CollectionSourceTransactions.vue?vue&type=script&lang=js"

import "./CollectionSourceTransactions.vue?vue&type=style&index=0&id=473e91c7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473e91c7"]])

export default __exports__